import { OptionType } from "~/Components/DynamicForm/DynamicForm";
import { corporateCMSApi } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";

const fetchDataAndTransform = async (url: string): Promise<OptionType[]> => {
  try {
    const res = await corporateCMSApi.get(`${url}`);
    if (res?.data) {
      return res.data
        .filter((item: any) => item.published === true || item.published?.toString().toLowerCase() === "true")
        .map((item: any) => ({
          label: decodeHTML(item.title),
          value: item.title,
        }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchParentOptions = async (): Promise<OptionType[]> => {
  return fetchDataAndTransform("/api/airport-academy-achievement/");
};
